<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <app-loading :value="loadingValue" :loading="isLoading && !BGProgress" :loadingText="loadingText" :rotate="loadingRotate" :color="loadingColor"></app-loading>
      <v-app v-show="!photoEdit && !imageCrop" id="inspire" class="app white">
        <div
          class="app-top-chrome"
          :class="{ 'app-top-chrome--fixed': headerFixed }"
          :style="headerFixed ? { height: headerHeight + 'px' } : null"
        >
          <div class="app-top-chrome__inner" :class="{ 'app-top-chrome__inner--fixed': headerFixed }">
            <app-toolbar class="app--toolbar"></app-toolbar>
            <release-banner @dismissed="onReleaseBannerDismissed"></release-banner>
          </div>
        </div>
        <template v-if="!forceFullScreen">
          <v-menu
            transition="slide-y-transition"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn fab small absolute class="white lighten-2 pf-text-teal" icon id="changeCover" v-on="on">
                <span class="grey lighten-2">
                  <v-icon size="17">camera_alt</v-icon>
                </span>
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="addBannerImage('banner_photo')">
                <v-list-tile-action>
                  <v-icon size="22">image</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="pf-menu-text">Change Banner</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="editBannerImage" v-if="session.role() === 'parent' ? Account.banner_photo && Account.banner_photo !== '' : (session.role() === 'child' ? Child.banner_photo && Child.banner_photo !== '' : Agency.banner_photo && Agency.banner_photo !== '')">
                <v-list-tile-action>
                  <v-icon size="22">edit</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="pf-menu-text">Edit Banner</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="addBannerImage('mobile_banner')">
                <v-list-tile-action>
                  <v-icon size="22">image</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="pf-menu-text">Change Mobile Banner</v-list-tile-title>
              </v-list-tile>
              <!-- <v-list-tile @click="editBannerImage('mobile_banner')" v-if="session.role() === 'parent' ? Account.mobile_banner && Account.mobile_banner !== '' : Agency.mobile_banner && Agency.mobile_banner !== ''">
                <v-list-tile-action>
                  <v-icon size="22">edit</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="pf-menu-text">Edit Mobile Banner</v-list-tile-title>
              </v-list-tile> -->
            </v-list>
          </v-menu>
          <v-parallax :height="bannerHeight" :src="banner" class="parallax">
            <div v-if="(session.role() === 'parent' && Account.temp_banner && Account.temp_banner !== '') || (session.role() === 'child' && Child.temp_banner && Child.temp_banner !== '')" class="pf-banner-pending-label">
              PENDING APPROVAL
            </div>
            <v-layout row class="profileName hidden-xs-only">
              <v-flex sm12 offset-sm5 offset-md4 offset-lg3 class="nameWrapper">
                <span xs8 offset-xs1 class="grey--text text--darken-3 font-weight-bold text-uppercase">
                  {{ dashboardName }}
              </span>
              </v-flex>
              <v-divider class="bannerDivider"></v-divider>
            </v-layout>
            <v-layout absolute class="avatarRow hidden-xs-only">
              <v-flex xs12>
                <v-avatar size="230px" :style="backAvatar" class="pa-1 avatar" :class="{'pf-bg-teal': ['admin', 'agency'].indexOf(session.role()) > -1, 'white': ['admin', 'agency'].indexOf(session.role()) === -1}">
                  <div v-if="(session.role() === 'parent' && Account.temp_avatar && Account.temp_avatar !== '') || (session.role() === 'child' && Child.temp_avatar && Child.temp_avatar !== '')" class="pf-avatar-pending-label">
                    PENDING APPROVAL
                  </div>
                </v-avatar>
                  <v-menu
                    transition="slide-y-transition"
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn fab small class="white pf-text-teal" icon id="changePhoto" v-on="on">
                        <span class="grey lighten-2">
                          <v-icon size="17">camera_alt</v-icon>
                        </span>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile @click="addProfileImage">
                        <v-list-tile-action>
                        <v-icon size="22">image</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title class="pf-menu-text">Change Picture</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="gotoAlbums" v-if="session.role() === 'parent'">
                        <v-list-tile-action>
                        <v-icon size="22">collections</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title class="pf-menu-text">Choose Existing Photo</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="editProfileImage" v-if="session.role() === 'parent' ? Account.avatar && Account.avatar !== '' : (session.role() === 'child' ? Child.avatar && Child.avatar !== '' : (Agency.avatar && Agency.avatar !== ''))">
                        <v-list-tile-action>
                          <v-icon size="22">edit</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title class="pf-menu-text">Edit Picture</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
              </v-flex>
            </v-layout>
            <v-layout absolute class="avatarRowCenter hidden-sm-and-up">
              <v-flex xs12>
                <v-avatar size="150px" :style="backAvatar" class="pa-1 avatar" :class="{'pf-bg-teal': ['admin', 'agency'].indexOf(session.role()) > -1, 'white': ['admin', 'agency'].indexOf(session.role()) === -1}">
                  <div v-if="Account.temp_avatar && Account.temp_avatar !== ''" class="pf-avatar-pending-label">
                    PENDING APPROVAL
                  </div>
                </v-avatar>
                <v-menu
                    transition="slide-y-transition"
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn fab small class="white pf-text-teal" icon id="changePhotoMobile" v-on="on">
                        <span class="grey lighten-2">
                          <v-icon size="17">camera_alt</v-icon>
                        </span>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile @click="addProfileImage">
                        <v-list-tile-action>
                        <v-icon size="22">image</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title class="pf-menu-text">Change Picture</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="gotoAlbums" v-if="session.role() === 'parent'">
                        <v-list-tile-action>
                        <v-icon size="22">collections</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title class="pf-menu-text">Choose Existing Photo</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="editProfileImage" v-if="session.role() === 'parent' ? Account.avatar && Account.avatar !== '' : (session.role() === 'child' ? Child.avatar && Child.avatar !== '' : (Agency.avatar && Agency.avatar !== ''))">
                        <v-list-tile-action>
                          <v-icon size="22">edit</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title class="pf-menu-text">Edit Picture</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
              </v-flex>
            </v-layout>
          </v-parallax>
          <v-layout row class="profileNameMobile hidden-sm-and-up">
              <v-flex sm12 class="nameWrapper">
                <p xs8 offset-xs1 class="grey--text text--darken-3 font-weight-bold text-uppercase">
                  {{ dashboardName }}
              </p>
              </v-flex>
          </v-layout>
        </template>
        <v-layout id="pageHeader" :class="{'mt-5': $vuetify.breakpoint.smAndUp && !forceFullScreen }">
          <v-flex>
            <app-drawer class="hidden-md-and-down app--drawer"></app-drawer>
            <app-drawer-mini class="app--drawer hidden-lg-and-up"></app-drawer-mini>
          </v-flex>
          <v-flex xs12>
            

            <v-toolbar flat color="white" dense>
            <v-toolbar-side-icon class="blue--text" @click="handleDrawerToggle">
              <v-icon medium class="pf-text-teal">dehaze</v-icon>
            </v-toolbar-side-icon>
              <v-toolbar-title v-if="$route.meta.title">
                <h3 class="pf-main-head"><b>{{ $route.meta.title.toUpperCase() }}</b><span v-if="pageSubHeader"> &nbsp; / &nbsp; <span>{{ pageSubHeader }}</span></span></h3>
              </v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-content class="grey lighten-3 pa-3">
              <div class="page-wrapper white pa-3">
                <router-view :key="$route.fullPath"></router-view>
              </div>
               <!-- App Footer -->
            </v-content>
          </v-flex>
        </v-layout>
        <v-footer height="auto" class="pa-3 pf-bg-teal app--footer">
        <v-layout row wrap>
          <v-flex xs12 class="text-center">
          <span class="text-center body-1 white--text font-weight-light">CAIRS SOLUTIONS LLC &copy; {{ new Date().getFullYear() }}</span>
          </v-flex>
          <v-flex xs12 class="text-center mt-1">
          <span class="text-center body-1 white--text font-weight-light">
            <a :href="`${config.WPParams.host}terms-conditions/`" class="white--text font-weight-light" target="_blank">Terms & Conditions</a> |
            <a :href="`${config.WPParams.host}privacy-policy/`" class="white--text font-weight-light" target="_blank">Privacy Policy</a>
            </span>
          </v-flex>
        </v-layout>
          <!-- <router-link class="caption hidden-sm-and-down privacy white--text" to="/privacy">Privacy</router-link> -->
        </v-footer>

        <!-- Go to top -->
        <app-fab></app-fab>

      </v-app>
      <v-app v-show="photoEdit">
        <v-content>
          <v-layout>
          <v-flex xs12 class="text-center">
            <image-editor :photo="photoObject" :type="photoEditType" :active="photoEdit"></image-editor>
          </v-flex>
        </v-layout>
        </v-content>
      </v-app>
      <v-app v-show="imageCrop">
        <v-content>
          <v-layout>
          <v-flex xs12 class="text-center">
            <image-cropper :photo="avatarObject" :active="imageCrop"></image-cropper>
          </v-flex>
        </v-layout>
        </v-content>
      </v-app>
    </template>
    <template v-else>
      <app-loading :value="loadingValue" :loading="isLoading && !BGProgress" :loadingText="loadingText" :rotate="loadingRotate" :color="loadingColor"></app-loading>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
/* global session store moment Mediator $ config */
import AppDrawer from '@/components/AppDrawer';
import AppDrawerMini from '@/components/AppDrawerMini';
import AppLoading from '@/components/AppLoading';
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import ReleaseBanner from '@/components/ReleaseBanner';
import ImageEditor from '@/components/ImageEditor';
import ImageCropper from '@/components/ImageCropper';
import menu from '@/api/menu';
import AppEvents from  './event';
import { getCollection, getOne, create } from './helpers/helpers';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';

// The parent component for the app which contains the app layout
export default {
  components: {
    ImageEditor,
    AppDrawer,
    AppDrawerMini,
    AppToolbar,
    AppFab,
    AppLoading,
    ImageCropper,
    ReleaseBanner
  },
  data: () => ({
    config: config,
    session: session,
    snackbar: {
      show: false,
      text: '',
      color: '',
    },
    name: 'profile image',
    item: 1,
    items: [
      { title: 'Home', icon: 'dashboard' },
      { title: 'About', icon: 'question_answer' }
    ],
    right: null,
    pageSubHeader: '',
    drawer: false,
    isLoading: false,
    BGProgress: false,
    loadingText: 'Loading',
    loadingColor: 'teal',
    loadingRotate: true,
    photoEdit: false,
    imageCrop: false,
    photoObject: {},
    avatarObject: {},
    photoEditType: 'album',
    loadingValue: 0,
    forceFullScreen: false,
    headerFixed: false,
    headerHeight: 0
  }),

  computed: {

    dashboardName () {
      this.Account = this.Account;
      this.Agency = this.Agency;
      let name = '';
      if (session.role() === 'parent') {
        name = this.Account.name && this.Account.account_type === 'Couple' ? this.Account.name.split('/').join(' AND ') : this.Account.name && this.Account.name.indexOf('/') ? this.Account.name.split('/')[0] : this.Account.name;
      } else if (session.role() === 'child') {
        name = this.Child.name ? this.Child.name.split('/').join('AND') : null;
      } else {
        name = this.Agency.name;
      }
      return name;
    },
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
    Child: {
      get () {
        return store.state.Child;
      },
      set (value) {
        store.commit('setChild', value);
      }
    },
    Agency: {
      get () {
        return store.state.Agency;
      },
      set (value) {
        store.commit('setAgency', value);
      }
    },
    CaseWorker: {
      get () {
        return store.state.CaseWorker;
      },
      set (value) {
        store.commit('setCaseWorker', value);
      }
    },
    MyAgencies: {
      get () {
        return store.state.MyAgencies;
      },
      set (value) {
        store.commit('setMyAgencies', value);
      }
    },
    MyFamilies: {
      get () {
        return store.state.MyFamilies;
      },
      set (value) {
        store.commit('setMyFamilies', value);
      }
    },
    Conversation: {
      get () {
        return store.state.Conversation;
      },
      set (value) {
        store.commit('setConversation', value);
      }
    },
    Video: {
      get () {
        return store.state.Video;
      },
      set (value) {
        store.commit('setVideo', value);
      }
    },
    Timeline: {
      get () {
        return store.state.Timeline;
      },
      set (value) {
        store.commit('setTimeline', value);
      }
    },
    Project: {
      get () {
        return store.state.Project;
      },
      set (value) {
        store.commit('setProject', value);
      }
    },
    Log: {
      get () {
        return store.state.Log;
      },
      set (value) {
        store.commit('setLog', value);
      }
    },

    ...mapGetters(['AlbumPhoto', 'TimelineIcons']),

    bannerHeight () {
      return (450 * screen.width) / 1366;
    },
    banner: {
      get () {
        this.Account = this.Account;
        this.Agency = this.Agency;
        if (session.role() === 'parent') {
          return this.Account.temp_banner && this.Account.temp_banner !== '' ? this.Account.temp_banner : (this.Account.banner_photo || '/static/banner.jpg');
        } if (session.role() === 'child') {
          return this.Child.temp_banner && this.Child.temp_banner !== '' ? this.Child.temp_banner : (this.Child.banner_photo || '/static/banner.jpg');
        } else if (['agency', 'caseworker', 'admin'].indexOf(session.role()) > -1) {
          return this.Agency.banner_photo || '/static/banner.jpg';
        }
        else {
          return '/static/banner.jpg';
        }
      }
    },
    avatar: {
      get () {
        this.Account = this.Account;
        this.Agency = this.Agency;
        if (session.role() === 'parent') {
          return this.Account.temp_avatar && this.Account.temp_avatar !== '' ? this.Account.temp_avatar : (this.Account.avatar || '/static/profile-pic.jpg');
        } if (session.role() === 'child') {
          return this.Child.temp_avatar && this.Child.temp_avatar !== '' ? this.Child.temp_avatar : (this.Child.avatar || '/static/profile-pic.jpg');
        } else if (['agency', 'caseworker', 'admin'].indexOf(session.role()) > -1) {
          return this.Agency.avatar || '/static/profile-pic.jpg';
        }
        else {
          return '/static/profile-pic.jpg';
        }
      }
    },
    backAvatar () {
      return {
        background: 'url(' + this.avatar + ') 50% 50% / ' + (['admin', 'agency'].indexOf(session.role()) > -1 ? 'contain' : 'cover') + ' no-repeat',
        border: 'solid 4px #fff',
        imageOrientation: 'none'
      };
    }
  },
  watch: {
    session: {
      handler () {
        // if (!this.session.user) return;
        // console.log('watched session', this.session);
        // this.setAvatar();
        // this.setName();
      },
      deep: true
    },
    Timeline (value) {
      let i = 0;
      if (value && value[i]) {
        // Add the icons for the most recent object
        let timeline = value[i];
        if (typeof this.TimelineIcons[timeline.title] !== 'undefined') {
          timeline.icon = this.TimelineIcons[timeline.title].icon;
          timeline.color = this.TimelineIcons[timeline.title].color;
        } else {
          timeline.icon = 'new_releases';
          timeline.color = 'orange';              
        }
        value[i] = timeline;
        this.Timeline = value;
      }
    },
    Account (value) {
      this.initiateLayout(false);
    },
    Agency (value) {
      this.initiateLayout(false);
    }
  },

  beforeCreate () {
    // Set up events before the component is fully created
    // This ensures events are ready before any async operations
    this.$nextTick(() => {
      this.setEvents();
    });
  },
  created () {
    window.getApp = this;
    this.initiateLayout(true);

  },
  mounted () {
    this.isLoading = true;
    try {
      if (session.role() === 'parent') {
        if (Object.keys(this.Account).length === 0 && session.isOnline()) {
          this.initializeAccount();
        }
        
      } else if (['agency', 'caseworker'].indexOf(session.role()) > -1) {
        if (Object.keys(this.Agency).length === 0 && session.isOnline()) {
          this.initializeAgency();
        }
      }
    } catch (error) {
      console.error('Error initializing account or agency:', error);
    } finally {
      // Always hide loading after initialization
      this.isLoading = false;
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline())
    {
      // return;
      next({ path: '/login' });
    }
    else
    {
      next();
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleSCroll);
  },
  methods: {
    initiateLayout (isInit) {
      /* Check if any alert comes along - in case of redirect */
      let queryIndex = window.location.href.indexOf('?');
      if (queryIndex > -1) {
        let query = window.location.href.substring(queryIndex + 1);
        query = decodeURI(query);
        let alertIndex = query.indexOf('alert=');
        if (alertIndex > -1) {
          let alert = query.substring(alertIndex + 6);
          swal.fire({
            title: 'Update',
            text: alert,
            showConfirmButton: true,
          });
        }
      }
      
      window.addEventListener('scroll', this.handleSCroll);

      window.getApp = this;
      if (isInit) {
        AppEvents.forEach(item => {
          this.$on(item.name, item.callback);
        });
        // this.setEvents();
      }
    },
    // @vuese
    // Used to set the initial events
    setEvents () {

      if (typeof $ !== 'undefined') {
        this.setupJQueryEvents();
      } else {
        // Wait for jQuery to be available
        const checkJQuery = setInterval(() => {
          if (typeof $ !== 'undefined') {
            clearInterval(checkJQuery);
            this.setupJQueryEvents();
          }
        }, 100);
      }

      // Set up Vue events immediately
      this.setupVueEvents();
    },
    setupJQueryEvents () {
      const self = this;
      let loadingTextLoaded = false;

      $(document).ajaxSend((event, xhr, options) => {
        if (options.bgFetch) {
          xhr.timer = setTimeout(function () {
            self.isLoading = false;
          }, 1000);
        }

        if (!loadingTextLoaded && options && options.type) {
          let texts = {
            'GET': 'Loading',
            'PUT': 'Saving',
            'POST': 'Saving',
            'DELETE': 'Deleting'
          };
          self.loadingText = texts[options.type];
        }
        
        // Force loading state immediately
        if (!self.isLoading) {
          self.$nextTick(() => {
            self.isLoading = true;
          });
        }
      });

      $(document).ajaxStop(() => {
        if (self.isLoading) {
          self.$nextTick(() => {
            self.isLoading = false;
            self.loadingText = 'Loading';
            loadingTextLoaded = false;
          });
        }
      });

      $(document).ajaxError(() => {
        // Ensure loading stops on error
        if (self.isLoading) {
          self.$nextTick(() => {
            self.isLoading = false;
          });
        }
      });
    },
    setupVueEvents () {
      window.getApp.$on('photoEdit', (isActive, photo, type = 'album') => {
        this.photoEdit = isActive;
        this.photoObject = photo;
        this.photoEditType = type;
      });

      window.getApp.$on('imageCrop', (isActive, avatar) => {
        this.imageCrop = isActive;
        this.avatarObject = avatar;
      });

      window.getApp.$on('pageSubHeader', (subHeader) => {
        this.pageSubHeader = subHeader;
      });

      window.getApp.$on('fileProgress', progressEvent => {
        // Value is not used now
        this.loadingValue = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total), 10);
      });

      window.getApp.$on('AppProgress', isProgress => {
        this.isLoading = isProgress;
      });

      window.getApp.$on('BGProgress', BGProgress => {
        this.BGProgress = BGProgress;
      });

      window.getApp.$on('saveProgress', isProgress => {
        this.isLoading = isProgress;
        this.loadingText = 'Saving';
      });

      let loadingTextLoaded = false;
      window.getApp.$on('LoadingText', loadingText => {
        if (loadingText) {
          loadingTextLoaded = true;
          this.loadingText = loadingText;
        }
      });

      window.getApp.$on('LoadingText', (loadingText = null) => {
        if (loadingText) {
          this.loadingText = loadingText;
        }
      });

      window.getApp.$on('APP_BAD_REQUEST', error => {
        this.isLoading = false;
        this.snackbar = {
          show: true,
          color: 'red',
          text: typeof error === 'string' ? error : (error.error || error.message || 'Something went wrong! please try again')
          // text: 'Something went wrong! please try again'
        };
      });

      window.getApp.$on('ACCOUNT', async (messageEvent) => {
        // Account update
        if (messageEvent.data) {
          this.Account = messageEvent.data;
        }
      });

      window.getApp.$on('AGENCY', async (messageEvent) => {
        // Agency update
        if (messageEvent.data) {
          this.Agency = messageEvent.data;
        }
      });

      window.getApp.$on('NEW_MESSAGE', messageEvent => {
        if (messageEvent.data) {
          this.Conversation = messageEvent.data;
        }
      });

      window.getApp.$on('AGENCY_UPDATE', async (messageEvent) => {
        // Update done from agency side
        if (messageEvent.data) {
          this.Account = messageEvent.data;
          // Update the parent agency list
          let where = { 'account.account': this.Account.id };
          let attributes = 'name,createdAt,account,_id';
          let populate = [{ path: 'human', select: '_id name user' }];
          let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
          if (error) {
            console.log(error);
          } else {
            this.MyAgencies = data;
          }
        }
      });

      window.getApp.$on('ACCOUNT_UPDATE', async (messageEvent) => {
        // Update done from parent side
        if (messageEvent.data) {
          // Update the family list
          this.MyFamilies = messageEvent.data;
          // Update the Agency data
          let { error, data } = await getOne('Agency', this.Agency.id);
          if (error) {
            console.log(error);
          } else {
            this.Agency = data;
          }
        }
      });

      window.getApp.$on('VIDEO', async (messageEvent) => {
        // Video create, update or delete
        if (messageEvent.data) {
          let video = messageEvent.data;
          let action = messageEvent.payload.action;
          let existsIndex = this.Video.findIndex(x => x.id.toString() === video.id.toString());
          if (action !== 'delete_hard') {
            // Update the video if already exists
            if (existsIndex > -1) {
              this.Video[existsIndex] = video;
            } else {
              // Add the video if new
              this.Video.unshift(video);
            }
          } else if (existsIndex > -1) {
            // Delete if deleted
            this.Video.splice(existsIndex, 1);
          }
        }
      });

      window.getApp.$on('TIMELINE', async (messageEvent) => {
        // New Timeline created
        if (messageEvent.data) {
          let timeline = messageEvent.data;
          this.Timeline.unshift(timeline);
          this.Timeline = this.Timeline;
        }
      });

      window.getApp.$on('Project', async (messageEvent) => {
        // Project create, update or delete
        if (messageEvent.data) {
          let project = messageEvent.data;
          let action = messageEvent.payload.action;
          let existsIndex = this.Project.findIndex(x => x.id.toString() === project.id.toString());
          if (action !== 'delete_hard') {
            // Update the project if already exists
            if (existsIndex > -1) {
              this.Project[existsIndex] = project;
            } else {
              // Add the project if new
              this.Project.unshift(project);
            }
          } else if (existsIndex > -1) {
            // Delete if deleted
            this.Project.splice(existsIndex, 1);
          }
          this.Project = JSON.parse(JSON.stringify(this.Project));
        }
      });

      window.getApp.$on('Section', async (messageEvent) => {
        // Section create, update or delete
        if (messageEvent.data) {
          let section = messageEvent.data;
          let project = section.project;
          let action = messageEvent.payload.action;
          let projectIndex = this.Project.findIndex(x => x.id === project);
          let existsIndex = this.Project[projectIndex].section.findIndex(x => x.section.id === section.id);
          if (action !== 'delete_hard') {
            // Update the section if already exists
            if (existsIndex > -1) {
              this.Project[projectIndex].section[existsIndex] = section;
            } else {
              // Add the section if new
              this.Project[projectIndex].section.unshift(section);
            }
          } else if (existsIndex > -1) {
            // Delete if deleted
            this.Project[projectIndex].section.splice(existsIndex, 1);
          }
          this.Project = JSON.parse(JSON.stringify(this.Project));
        }
      });

      window.getApp.$on('Log', async (messageEvent) => {
        // Log create, update or delete
        if (messageEvent.data) {
          let log = messageEvent.data;
          let action = messageEvent.payload.action;
          if (action === 'create') {
            let existsIndex = this.Log.findIndex(x => x.id === log.id);
            // Update the Log if already exists
            if (existsIndex > -1) {
              this.Log[existsIndex] = log;
            } else {
              // Add the Log if new
              this.Log.unshift(log);
            }
            this.Log = JSON.parse(JSON.stringify(this.Log));
          }
        }
      });

      window.getApp.$on('FORCE_MINI_DRAWER', (forceFullScreen) => {
        this.forceFullScreen = forceFullScreen;
      });
    },
    // @vuese
    // Used to initialise the parent account data if not exists
    async initializeAccount () {
     
      this.isLoading = true;
      this.loadingText = 'Loading Account...';
      try {
        let entity = `Account`;
        let populate = ['human', 'contactInfo.country', 'contactInfo.state', 'template.template'];
        let { error, data } = await getOne(entity, session.getSession().adminUser ? session.getSession().user.human.account.id : 'Me', populate);
        if (error) {
          console.log(error);
        } else {
          this.Account = data;
        }
      } catch (error) {
        console.error('Error initializing account:', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to load account data. Please try again later.'
        };
      } finally {
        this.isLoading = false;
        this.loadingText = 'Loading';
      }
    },
    // @vuese
    // Used to initialize the agency data if not exists
    async initializeAgency () {
      this.isLoading = true;
      this.loadingText = 'Loading Agency...';
      try {
        let entity = `Agency`;
        const agencyId  = (['agency', 'caseworker'].indexOf(session.role()) > -1 ? (session.getSession().adminUser ? session.getSession().user.human.agency : 'Me') : this.CaseWorker.agency);
        let { error, data } = await getOne(entity, agencyId);
        if (error) {
          console.log(error);
        } else {
          this.Agency = data;
        }
      } catch (error) {
        console.error('Error initializing agency:', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to load agency data. Please try again later.'
        };
      } finally {
        this.isLoading = false;
        this.loadingText = 'Loading';
      }
    },
    // @vuese
    // Used to handle the click to toggle the app menu
    handleDrawerToggle () {
      // Fired when the user clicked to maximize/minimize the app menu
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    gotoAlbums () {
      swal.fire({
        type: 'info',
        title: 'Choose Existing Photo',
        text: 'You will be redirected to your ablum listing. Choose the option "Use as Avatar" from the menu on your photos',
        showCancelButton: false,
        confirmButtonColor: '#7ac142',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.$router.push({ path: `/albums` });
        }
      });
    },
    // @vuese
    // Used to upload the profile image for the user
    addProfileImage () {
      let albumId = '';
      const client = global.filestack.init(config.filestack.client);
      const humanId = session.user().human.id;
      if (session.role() === 'parent') {
        albumId = this.Account.avatar_album;
      } else if (session.role() === 'child') {
        albumId = this.Child.avatar_album;
      } else {
        albumId = this.Agency.avatar_album;
      }
      const options = {
        fromSources: ['local_file_system'],
        maxFiles: 1,
        accept: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
        uploadInBackground: false,
        transformations: {
          crop: { aspectRatio: 300 / 228, force: true }
        },
        storeTo: {
          location: 'S3',
          path: '/' + config.s3Domain + '/' + humanId + '/avatar/' + albumId + '/original/',
          access: 'public'
        },
        onFileSelected (file) {
          let filenameArr = file.filename.split('.');
          let ext = filenameArr.pop();
          let filename = filenameArr.join('.');
          filename = filename.replace(/[^0-9a-z]/gi, '');
          return { name: filename + '_' + (new Date().getTime()) + '.' + ext };
        },
        onUploadDone: (response) => {
          let original_url = config.s3BucketPath + response.filesUploaded[0].key;
          let avatarThumb = original_url.replace('/original/', '/thumb/');
          // After uploading
          $('.avatar').css('background', 'url(/static/loading_temp.gif) 50% 50% / 25% no-repeat');
          setTimeout(() => {
            if (session.role() === 'parent') {
              this.Account.avatar = avatarThumb;
            } else if (session.role() === 'child') {
              this.Child.avatar = avatarThumb;
            } else {
              this.Agency.avatar = avatarThumb;
            }
          }, 5000);
        },
        
      };
      if (['admin', 'agency'].indexOf(session.role()) > -1) {
        options.transformations = {
          // Free crop
          crop: { force: true }
        };
      }
      client.picker(options).open();
    },
    // @vuese
    // Used to upload the banner image
    async addBannerImage (type) {
      let self = this;
      let albumId = '';
      const client = global.filestack.init(config.filestack.client);
      const humanId = session.user().human.id;
      if (session.role() === 'parent') {
        albumId = this.Account.banner_album;
      } else if (session.role() === 'child') {
        albumId = this.Child.banner_album;
      } else {
        albumId = this.Agency.banner_album;
      }
      let cropRatio = 1026 / 450;
      if (type === 'mobile_banner') {
        /* Set the crop ratio */
        cropRatio = 800 / 667;

        /* Create the mobile banner album if not exists - Newly done */
        let roleEntity = session.role() === 'child' ? 'Child' : (session.role() === 'parent' ? 'Account' : 'Agency');
        if (roleEntity && !self[roleEntity].mobile_banner_album) {
          let mobileBannerAlbum = {
            name: 'Mobile Banners',
            type: 'Mobile Banner'
          };
          mobileBannerAlbum[session.role()] = self[roleEntity]._id;

          let { error, data, status } = await create('Album', mobileBannerAlbum);
          if (error) {
            console.log('error', error);
            self.snackbar = {
              show: true,
              color: 'red',
              text: 'Failed to create the mobile banner album, please refresh and try again'
            };
          } else {
            self[roleEntity].mobile_banner_album = data.id;
            albumId = data.id;
          }
        } else {
          albumId = self[roleEntity].mobile_banner_album;
        }
      }
      const options = {
        fromSources: ['local_file_system'],
        maxFiles: 1,
        accept: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
        uploadInBackground: false,
        transformations: {
          crop: { aspectRatio: cropRatio, force: true }
        },
        storeTo: {
          location: 'S3',
          path: '/' + config.s3Domain + '/' + humanId + '/banner/' + albumId + '/original/',
          access: 'public'
        },
        onFileSelected (file) {
          let filenameArr = file.filename.split('.');
          let ext = filenameArr.pop();
          let filename = filenameArr.join('.');
          filename = filename.replace(/[^0-9a-z]/gi, '');
          return { name: filename + '_' + (new Date().getTime()) + '.' + ext };
        },
        onUploadDone: (response) => {
          let original_url = config.s3BucketPath + response.filesUploaded[0].key;
          // After uploading
          if (session.role() === 'parent') {
            this.Account[type] = original_url;
          } else if (session.role() === 'child') {
            this.Child[type] = original_url;
          } else {
            this.Agency[type] = original_url;
          }
        }
      };
      client.picker(options).open();
    },
    editProfileImage () {
      let avatar;
      if (session.role() === 'parent' && this.Account.avatar) {
        avatar = {
          original_url: this.Account.avatar.replace('/thumb/', '/original/'),
          thumb_url: this.Account.avatar,
          webview_url: this.Account.avatar.replace('/thumb/', '/webview/'),
        };
        window.getApp.$emit('photoEdit', true, avatar, 'avatar');
      } else if (session.role() === 'child' && this.Child.avatar) {
        avatar = {
          original_url: this.Child.avatar.replace('/thumb/', '/original/'),
          thumb_url: this.Child.avatar,
          webview_url: this.Child.avatar.replace('/thumb/', '/webview/'),
        };
        window.getApp.$emit('photoEdit', true, avatar, 'avatar');
      } else if (this.Agency.avatar) {
        avatar = {
          original_url: this.Agency.avatar.replace('/thumb/', '/original/'),
          thumb_url: this.Agency.avatar,
          webview_url: this.Agency.avatar.replace('/thumb/', '/webview/'),
        };
        window.getApp.$emit('photoEdit', true, avatar, 'avatar');
      }
    },
    editBannerImage () {
      if (session.role() === 'parent' && this.Account.banner_photo) {
        window.getApp.$emit('photoEdit', true, { original_url: this.Account.banner_photo }, 'banner');
      } else if (session.role() === 'child' && this.Child.banner_photo) {
        window.getApp.$emit('photoEdit', true, { original_url: this.Child.banner_photo }, 'banner');
      } else if (this.Agency.banner_photo) {
        window.getApp.$emit('photoEdit', true, { original_url: this.Agency.banner_photo }, 'banner');
      }
    },
    // @vuese
    // Used to make the app toolbar + release banner sticky while scrolling past 70px.
    // @arg event - Browser event while scrolling
    handleSCroll (event) {
      const chrome = this.$el && this.$el.querySelector('.app-top-chrome');
      if (!chrome) {
        return;
      }
      if (window.scrollY > 70) {
        if (!this.headerFixed) {
          this.headerHeight = chrome.offsetHeight;
          this.headerFixed = true;
        }
      } else if (this.headerFixed) {
        this.headerFixed = false;
        this.headerHeight = 0;
      }
    },
    onReleaseBannerDismissed () {
      this.$nextTick(() => {
        const inner = this.$el && this.$el.querySelector('.app-top-chrome__inner');
        if (inner && this.headerFixed) {
          this.headerHeight = inner.offsetHeight;
        }
      });
    },
    functionCall (fnName) {
      if (fnName) {
        this[fnName]();
      }
    }
  }

};
</script>


<style lang="stylus" scoped>
  .setting-fab
    top:50%!important;
    right:0;
    border-radius:0
  .page-wrapper
    min-height:calc(100vh - 100px);

  .app--footer span, .app--footer .privacy {
    width: 100%;
    text-align: center;
  }
  .avatarRow {
    position: absolute;
    bottom: -45px;
    left: 75px;
  }
  .avatarRowCenter {
    position: absolute;
    top: 80px;
    left: calc(50% - 75px);

  }
  .avatar {
    box-shadow: 0px 12px 10px -5px #cbcbcb;
  }
  .avatar img {
    width: 100%;
    height: 100%; 
  }
  .profileName {
    position: absolute;
    width: 100%
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    height: 50px;
    margin: 0 -1rem;
    font-size: 20px;
  }
  .profileNameMobile {
    width: 100%
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    height: 50px;
    margin-top: 110px !important;
    font-size: 20px;
    text-align: center;
    margin-top: 35px;
  }
  .profileName span {
    border-radius: 70px;
  }
  .profileNameMobile p {
    border-bottom: 1px solid #019d8c;
    padding: 5px 0;
    margin: 10px 0;
    width: 100%;
  }
  .nameWrapper {
    // padding: 10px 0;
    display: inline-flex;
    align-items: center;
  }
  #changePhoto {
    position: relative;
    top: 75px;
    left: -65px;
  }
  #changePhotoMobile {
    position: relative;
    top: 50px;
    left: -50px;
  }
  #changePhoto span, #changeCover span, #changePhotoMobile span {
    height: 32px;
    width: 32px;
    border-radius: 50px;
  }
  .parallax {
    overflow: visible;
    z-index: 1;
  }
  .app--drawer {
    margin-top: 48px;
  }
  .bannerDivider {
    width: 100%;
    position: absolute;
    bottom: -4px;
  }
  #changeCover {
    right: 10px;
    top: 55px;
    z-index: 2;
  }
  .app-top-chrome__inner--fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue